import { unreachable } from '../../../../ts-utils';
export const hiddenComponentEffectsGuard = (state, newEffectsState) => {
    switch (state.componentState) {
        case 'HIDDEN':
            return {
                componentState: 'HIDDEN',
                effects: undefined,
            };
        case 'VISIBLE':
            return {
                componentState: 'VISIBLE',
                effects: {
                    ...state.effects,
                    ...newEffectsState,
                },
            };
        default:
            throw unreachable(state);
    }
};
//# sourceMappingURL=hidden-component-effects-guard.js.map